import React, { useState } from 'react';
import { TextField, Button, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchBar = ({ onSearch }) => {
  const [query, setQuery] = useState('');

  const handleSearch = () => {
      onSearch({ query }); // Pass the query to the onSearch function
  };

  return (
    <Box display="flex" alignItems="center">
      <SearchIcon sx={{ marginRight: '0.5rem', color: '#888' }} />
      <TextField
        placeholder="Search a term or phrase."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        sx={{ 
          flexGrow: 1, 
          width: '100%', 
          borderColor: 'white !important',
          '& .MuiInputBase-root': { 
            border: 'none', 
            borderColor: 'white',
          },
          '& .MuiInputBase-input': {
            border: 'none', 
            outline: 'none', 
            borderColor: 'white',
          },
          '&:before': {
            border: 'none', 
            borderColor: 'white',
          },
          '&:after': {
            border: 'none', 
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'white !important', 
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'white !important', 
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'white !important', 
          },
        }} 
      />
      <Button
        variant="outlined"
        color="primary"
        sx={{ marginLeft: '0.5rem', textTransform: 'none', fontSize: '14px', fontWeight: 'bold', border: '1.5px solid ' }}
        onClick={handleSearch} // Call handleSearch directly
      >
        Search
      </Button>
    </Box>
  );
};

export default SearchBar;